export default ($sliders) => {
  $sliders.on('afterChange', (event, slick) => {
    const $activeSlides = slick.$slider.find('.slick-slide.slick-active');
    const $images = $activeSlides.find('.lazy');

    $images.each((index, item) => {
      const $img = $(item);
      const $picture = $img.closest('picture');
      $picture.find('source').each((i, source) => {
        const $source = $(source);
        $source.attr('data-srcset', $source.attr('data-base-srcset'));
      });

      const imgBaseSrcset = $img.attr('data-base-srcset');
      const imgCurrentSrcset = $img.attr('srcset');

      if (imgCurrentSrcset === imgBaseSrcset) {
        return;
      }

      $img.attr('data-srcset', imgBaseSrcset);
      LazyLoad.load(item);
    });
  });
};
